// API
import projectsApi from '@/api/v1/projects';
// Models
import projectModel from '@/models/project';

export default {
  data() {
    return {
      project: projectModel.project,
    };
  },
  created() {
    this.fetchProject();
  },
  watch: {
    $route() {
      this.fetchProject();
    },
  },
  methods: {
    setProject(project) {
      const vm = this;
      project.to_collect /= 100;
      vm.project = project;
      vm.project.category_id = project.category.id;
      vm.project.country_id = project.country.id;
      // find translation by application language, if it doesn't exist take first one that exists
      vm.project.translation = vm.project.translations.find(t =>
        t.locale === localStorage.getItem('lang'),
      );
      if (!vm.project.translation) {
        vm.project.translation = vm.project.translations[0] ? vm.project.translations[0] : {};
      }
    },
    fetchProject() {
      if (this.$route.params.id) projectsApi.getProject(this.$route.params.id, this.setProject);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/showProject.js